import { Component } from 'react';
import { connect } from 'react-redux';
import { Route } from 'react-router-dom';
import { getLocation } from '@s20/selectors/helpers/router.selectors';
import { getIsAuthenticated, getUser } from '@s20/selectors/features/common.selectors';
import { Can } from '../Can';
import { ApplicationPaths, LoginActions, QueryParameterNames } from './ApiAuthorizationConstants';
import { NoPermission } from './NoPermission';
import authService from './AuthorizeService';
import { Login } from './Login';

class AuthorizeRoute extends Component {
    componentDidMount() {
        this._subscription = authService.subscribe(() => this.authenticationChanged());
        this.populateAuthenticationState();
    }

    componentWillUnmount() {
        authService.unsubscribe(this._subscription);
    }

    async authenticationChanged() {
        this.setState({ ready: false, authenticated: false });
        await this.populateAuthenticationState();
    }

    async populateAuthenticationState() {
        const authenticated = await authService.isAuthenticated();
        this.setState({ ready: true, authenticated });
    }

    render() {
        const {
            location, perm, action, component: Component, isAuthenticated, changePassword, ...rest
        } = { ...this.props };

        const link = document.createElement('a');
        link.href = location.pathname;

        // const returnUrl = `${link.protocol}//${link.host}${link.pathname}${link.search}${link.hash}`;
        // const redirectUrl = `${ApplicationPaths.Login}?${QueryParameterNames.ReturnUrl}=${encodeURI(returnUrl)}`;

        // Force user to password reset page if needed - cannot navigate to any other path that requires
        // authorization until this is done. Preserve the deep link as returnUrl so that
        // ResetPassword.cshtml.cs can redirect back to it after a successful reset.
        if (changePassword) {
            const isAuthPath = window.location.pathname.startsWith(`${ApplicationPaths.ApiAuthorizationPrefix}/`);
            const returnUrl = `${window.location.pathname}${window.location.search}${window.location.hash}`;
            const redirectUrl = isAuthPath
                ? `${window.location.origin}${ApplicationPaths.IdentityChangePassword}`
                : `${window.location.origin}${ApplicationPaths.IdentityChangePassword}?${QueryParameterNames.ReturnUrl}=${encodeURIComponent(returnUrl)}`;
            window.location.replace(redirectUrl);
            return null;
        }

        if (perm && action && isAuthenticated) {
            return (
                <>
                    <Can
                        do={action}
                        on={perm}
                    >
                        <Route
                            {...rest}
                            location={location}
                            render={(props) => <Component {...props} />}
                        />
                    </Can>

                    <Can
                        not
                        do={action}
                        on={perm}
                    >
                        <Route
                            {...rest}
                            render={() => <NoPermission />}
                        />
                    </Can>
                </>
            );
        }

        if (!isAuthenticated) {
            return <Login action={LoginActions.Login} />;
        }

        return (
            <Route
                {...rest}
                location={location}
                component={Component}
            />
        );
    }
}

const mapStateToProps = (state) => ({
    changePassword: getUser(state)?.changePassword,
    isAuthenticated: getIsAuthenticated(state),
    location: getLocation(state),
});

export default connect(mapStateToProps)(AuthorizeRoute);